import React from 'react';

import { Chip } from '@material-ui/core';
import clsx from 'clsx';

import useStyles from './TagsInline.styles';

type Props = {
  tags: string[];
  className?: string;
};

const TagsInline: React.FC<Props> = ({ tags, className }) => {
  const styles = useStyles();

  if (!tags || tags.length === 0) return null;

  return (
    <div className={clsx(styles.container, className)}>
      {tags.map(tag => (
        <Chip key={tag} className={styles.tag} label={tag} size='small' />
      ))}
    </div>
  );
};

export default TagsInline;
